export default "__VITE_ASSET__f$XCiwCS__"